<template>
  <VCard
    key="code"
    class="login-form"
  >
    <div class="logo">
      <VLogo/>
    </div>

    <header>Введите код для входа</header>

    <VForm
      ref="form"
    >
      <div class="form">
        <VInput
          v-model="form.email"
          label="Почта"
          layout="vertical"
          type="email"
          autocomplete="email"
          required
          hide-asterisk
          @keyup.enter="onSubmit"
        />

        <VInput
          v-model="form.code"
          label="Полученный код"
          layout="vertical"
          type="text"
          required
          hide-asterisk
          :validate-method="validateCode"
          @keyup.enter="onSubmit"
        >
          <template #helper-text>
            <template v-if="approveError">
              Код не совпал с тем, что мы отправили вам.
              <br>
              Попробуйте ещё раз или
              <a href="#"
              @click.prevent="$router.push('/login/restore')"
              >
              получите код повторно
              </a>
            </template>

            <template v-else>
              Введите код, который мы отправили вам. Если не получили код - проверьте адрес почты и
              <a
              href="#"
              @click.prevent="$router.push('/login/restore')"
              >
              получите код повторно
              </a>
            </template>
          </template>
        </VInput>

        <FormAgreementCheckbox :form="form"/>

        <div class="actions-wrap">
          <VButton
            :disabled="isLoading"
            theme="primary"
            @click="onSubmit"
          >
            Войти
          </VButton>

          <VButton @click="$router.push('/login')">
            Отмена
          </VButton>
        </div>
      </div>
    </VForm>
  </VCard>
</template>

<script>
import { getUserHomePath } from '@/router';

import GlobalLoader from "@/core/services/GlobalLoader/GlobalLoader";

import LoginForm from "@/pages/common/LoginPage/LoginForm";
import ContractsPublicDAO from "@/domains/Contracts/ContractsPublicDAO.js";

import VLogo from "@/lib/components/VLogo/VLogo.vue";
import ValidationFormMixin from "@/mixins/validation-form-mixin";
import FormAgreementCheckbox from "@/pages/common/LoginPage/components/FormAgreementCheckbox.vue";

export default defineComponent({
  name: 'CodeView',

  mixins: [
    ValidationFormMixin
  ],

  components: {
    VLogo,
    FormAgreementCheckbox
  },

  data() {
    return {
      approveError: false,

      form: new LoginForm(),
    };
  },

  computed: {
    isLoading() {
      return GlobalLoader.isVisible;
    },

    formValid() {
      return this.form.allAgreementsAccepted
        && this.form.email
        && this.form.code;
    }
  },

  methods: {
    async onSubmit() {
      if (this.isLoading === true || this.formValid === false) {
        return;
      }

      await this.validate();

      if (this.isValid === false) {
        return;
      }

      this.form.saveAgreementFlagsToLocalStorage();

      try {
        this.approveError = false;
        await this.$core.acl.login(this.form.email, null, this.form.code);

        const contracts = await this.form.getAcceptedContracts();
        await ContractsPublicDAO.accept(contracts);

        /** Обновляем юзера, чтобы contractAcceptances подтянулись */
        await this.$core.acl.updateCurrentUserData();
        this.$router.push({path: getUserHomePath()});
      } catch (error) {
        this.approveError = true;
      }
    },

    validateCode(value) {
      if (typeof value !== 'string') {
        return null;
      }

      if (value.length === 4) {
        return null;
      } else {
        return 'Код должен содержать 4 знака';
      }
    },
  },
});
</script>
